import { Component, ViewEncapsulation } from '@angular/core';
import { MatSnackBarRef } from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'copo-snackbar-submit-guarantee',
	templateUrl: './snackbar-submit-guarantee.component.html',
	styleUrl: './snackbar-submit-guarantee.component.css',
	encapsulation: ViewEncapsulation.Emulated,
	imports: [TranslateModule]
})
export class SnackbarSubmitGuaranteeComponent {
	constructor(
		private readonly snackBarRef: MatSnackBarRef<SnackbarSubmitGuaranteeComponent>
	) {}

	dismiss() {
		this.snackBarRef.dismiss();
	}
}
